import type {ReactElement} from 'react';
import React from 'react';
import {BaseRemoveColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-remove-color-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromEffectsOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveSlideItem';

interface SlideshowItemRemoveColorOptionProps {
  onClickColorFill(): void;
}

export function SlideshowItemRemoveColorOption({...props}: SlideshowItemRemoveColorOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const removeColor = useGetKeyFromEffectsOfActiveSlideItem('removeColor');
  const removeColorThickness = useGetKeyFromEffectsOfActiveSlideItem('removeColorThickness');
  const removeColorValue = useGetKeyFromEffectsOfActiveSlideItem('removeColorValue');

  if (!activeItem || !activeSlideUID) {
    throw new Error('Active item or active slide is not defined in slideshow item effects options');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, got ${activeItem.gitype} instead`);
  }

  if (removeColor === undefined || removeColorValue === undefined || removeColorThickness === undefined) {
    throw new Error('blackandwhite is undefined for active slide item');
  }

  const onToggleRemoveColor = (): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      effects: {
        removeColor: !removeColor,
      },
    });
  };

  const updateTolerance = (updatedValue: number, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        effects: {
          removeColorThickness: updatedValue,
        },
      },
      {
        undoable,
      }
    );
  };

  return (
    <BaseRemoveColorOption
      removeColorThickness={removeColorThickness}
      removeColor={removeColor}
      removeColorValue={removeColorValue}
      onClickColorFill={(): void => {
        props.onClickColorFill();
      }}
      onToggleRemoveColor={onToggleRemoveColor}
      updateTolerance={updateTolerance}
    />
  );
}
